import { sluggify } from '/web/app/themes/umdoisesportes/assets/scripts/common/functions'

const createList = (headingLevels) => {
  const headings = document.querySelectorAll(headingLevels.map((level) => level).join(', '))
  if (!headings.length) return

  const tocList = []

  headings.forEach((heading) => {
    let id = heading.getAttribute('id')
    if (!id) {
      const text = heading.textContent ? heading.textContent.trim() : ''
      id = sluggify(text)
      if (id) {
        heading.setAttribute('id', id)
      }
    }

    tocList.push({
      id,
      text: heading.textContent
    })
  })

  let listHTML = '<ul class="nav__list">'

  tocList.forEach((item) => {
    listHTML += `<li class="list__item"><a href="#${item.id}" class="item__link">${item.text}</a></li>`
  })

  listHTML += '</ul>'

  return {
    listHTML,
    headings
  }
}

export const initTocBlock = () => {
  const blocks = document.querySelectorAll('.block-acf---toc')
  if (!blocks.length) return

  blocks.forEach((block) => {
    const { headings, listHTML } = createList(JSON.parse(block.dataset.headingLevels))

    const nav = block.querySelector('.toc__nav')
    if (nav) {
      nav.innerHTML = listHTML
    }

    if (block.dataset.scrollTracking) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('id')
          if (entry.intersectionRatio > 0) {
            block.querySelector(`a[href="#${id}"]`).classList.add('item__link--active')
          } else {
            block.querySelector(`a[href="#${id}"]`).classList.remove('item__link--active')
          }
        })
      })

      // Track all headings that have an `id` applied
      headings.forEach((heading) => {
        observer.observe(heading)
      })
    }
  })
}

initTocBlock()
